// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VisitCard-module__font-s-10___qrF1n {
  font-size: 10px !important;
}

.VisitCard-module__font-s-12___gIXBY {
  font-size: 12px !important;
}

.VisitCard-module__font-s-13___w66j6 {
  font-size: 13px !important;
}

.VisitCard-module__font-s-14___uRsM7 {
  font-size: 14px !important;
}

.VisitCard-module__font-s-15___BhIoa {
  font-size: 15px !important;
}

.VisitCard-module__font-s-16___oZeG0 {
  font-size: 16px !important;
}

.VisitCard-module__font-s-18___u21na {
  font-size: 18px !important;
}

.VisitCard-module__font-s-20___Hvxsr {
  font-size: 20px !important;
}

.VisitCard-module__font-s-22___NBR20 {
  font-size: 22px !important;
}

.VisitCard-module__font-s-28___rmqBd {
  font-size: 28px !important;
}

.VisitCard-module__font-w-400___BpTCa {
  font-weight: 400 !important;
}

.VisitCard-module__font-w-500___Bxqr_ {
  font-weight: 500 !important;
}

.VisitCard-module__font-w-600___RycOf {
  font-weight: 600 !important;
}

.VisitCard-module__font-w-700___hlrie {
  font-weight: 700 !important;
}

.VisitCard-module__p-5___FOjBl {
  padding: 5px !important;
}

.VisitCard-module__p-12___CtKEc {
  padding: 12px !important;
}

.VisitCard-module__p-16___U7Y7t {
  padding: 16px !important;
}

.VisitCard-module__p-30___izHlB {
  padding: 30px !important;
}

.VisitCard-module__p-b-0___MU94H {
  padding-bottom: 0 !important;
}

.VisitCard-module__p-b-5___bFPAS {
  padding-bottom: 5px !important;
}

.VisitCard-module__p-b-10___nwgoa {
  padding-bottom: 10px !important;
}

.VisitCard-module__p-b-12___Kc1me {
  padding-bottom: 12px !important;
}

.VisitCard-module__p-b-16___dJ4Dm {
  padding-bottom: 16px !important;
}

.VisitCard-module__p-b-18___bEzZi {
  padding-bottom: 18px !important;
}

.VisitCard-module__p-b-20___ibEa6 {
  padding-bottom: 20px !important;
}

.VisitCard-module__p-b-25___DdpHW {
  padding-bottom: 25px !important;
}

.VisitCard-module__p-b-30___vAbs8 {
  padding-bottom: 30px !important;
}

.VisitCard-module__p-b-50___PxCsz {
  padding-bottom: 50px !important;
}

.VisitCard-module__p-t-0___WFBpv {
  padding-top: 0 !important;
}

.VisitCard-module__p-t-12___rSfuw {
  padding-top: 12px !important;
}

.VisitCard-module__p-t-16___v1DVY {
  padding-top: 16px !important;
}

.VisitCard-module__p-t-18___ED5Kx {
  padding-top: 18px !important;
}

.VisitCard-module__p-t-20___w2bdn {
  padding-top: 20px !important;
}

.VisitCard-module__p-t-30___voVZL {
  padding-top: 30px !important;
}

.VisitCard-module__p-t-40___vN2PA {
  padding-top: 40px !important;
}

.VisitCard-module__p-t-50___HVtOB {
  padding-top: 50px !important;
}

.VisitCard-module__p-l-20___GUJGv {
  padding-left: 20px !important;
}

.VisitCard-module__p-l-30____t9fI {
  padding-left: 30px !important;
}

.VisitCard-module__p-l-40___XyBJe {
  padding-left: 40px !important;
}

.VisitCard-module__p-r-16___HWowV {
  padding-right: 16px !important;
}

.VisitCard-module__p-r-20___xJOlN {
  padding-right: 20px !important;
}

.VisitCard-module__p-r-30___usQUR {
  padding-right: 30px !important;
}

.VisitCard-module__p-r-50___nO225 {
  padding-right: 50px !important;
}

.VisitCard-module__p-r-60___bMjbt {
  padding-right: 60px !important;
}

.VisitCard-module__m-b-1___QsHJk {
  margin-bottom: 1px !important;
}

.VisitCard-module__m-b-2___bhV7P {
  margin-bottom: 2px !important;
}

.VisitCard-module__m-b-6___SdN63 {
  margin-bottom: 6px !important;
}

.VisitCard-module__m-b-8___BSmTH {
  margin-bottom: 8px !important;
}

.VisitCard-module__m-b-10___lS_jU {
  margin-bottom: 10px !important;
}

.VisitCard-module__m-b-14___rHIRu {
  margin-bottom: 14px !important;
}

.VisitCard-module__m-b-16___Usj5a {
  margin-bottom: 16px !important;
}

.VisitCard-module__m-b-20___DzyMH {
  margin-bottom: 20px !important;
}

.VisitCard-module__m-b-22___hKokZ {
  margin-bottom: 22px !important;
}

.VisitCard-module__m-b-24___xdgUg {
  margin-bottom: 24px !important;
}

.VisitCard-module__m-b-30___FsYlM {
  margin-bottom: 30px !important;
}

.VisitCard-module__m-b-32___s1jkL {
  margin-bottom: 32px !important;
}

.VisitCard-module__m-b-40___ok2lJ {
  margin-bottom: 40px !important;
}

.VisitCard-module__m-t-2___K_Eem {
  margin-top: 2px !important;
}

.VisitCard-module__m-t-3___mY5S4 {
  margin-top: 3px !important;
}

.VisitCard-module__m-t-4___th6ZD {
  margin-top: 4px !important;
}

.VisitCard-module__m-t-5____YOg3 {
  margin-top: 5px !important;
}

.VisitCard-module__m-t-8___RnZzg {
  margin-top: 8px !important;
}

.VisitCard-module__m-t-10___HBI5D {
  margin-top: 10px !important;
}

.VisitCard-module__m-t-15___YLZ8q {
  margin-top: 15px !important;
}

.VisitCard-module__m-t-16___blLyi {
  margin-top: 16px !important;
}

.VisitCard-module__m-t-20___DbP0f {
  margin-top: 20px !important;
}

.VisitCard-module__m-t-22___rihb2 {
  margin-top: 22px !important;
}

.VisitCard-module__m-t-30___a5dD2 {
  margin-top: 30px !important;
}

.VisitCard-module__m-t-32___Upqu8 {
  margin-top: 32px !important;
}

.VisitCard-module__m-l-auto___y_iog {
  margin-left: auto !important;
}

.VisitCard-module__m-l-4___tpsRb {
  margin-left: 4px !important;
}

.VisitCard-module__m-l-5___dkA9k {
  margin-left: 5px !important;
}

.VisitCard-module__m-l-6___UOpjn {
  margin-left: 6px !important;
}

.VisitCard-module__m-l-8___U0hG4 {
  margin-left: 8px !important;
}

.VisitCard-module__m-l-10___GCLem {
  margin-left: 10px !important;
}

.VisitCard-module__m-l-16___bSxKQ {
  margin-left: 16px !important;
}

.VisitCard-module__m-l-20___uCk3D {
  margin-left: 20px !important;
}

.VisitCard-module__m-l-24___VhVR6 {
  margin-left: 24px !important;
}

.VisitCard-module__m-l-30___ZyBCO {
  margin-left: 30px !important;
}

.VisitCard-module__m-l-35____2mXI {
  margin-left: 35px !important;
}

.VisitCard-module__m-l-40___crkfs {
  margin-left: 40px !important;
}

.VisitCard-module__m-r-8___ZsHVF {
  margin-right: 8px !important;
}

.VisitCard-module__m-r-10___hFPgp {
  margin-right: 10px !important;
}

.VisitCard-module__m-r-16___rAGf6 {
  margin-right: 16px !important;
}

.VisitCard-module__m-r-20___OL7xT {
  margin-right: 20px !important;
}

.VisitCard-module__m-r-24___SesnN {
  margin-right: 24px !important;
}

.VisitCard-module__m-r-30___HBk61 {
  margin-right: 30px !important;
}

.VisitCard-module__m-r-40___xcTZC {
  margin-right: 40px !important;
}

.VisitCard-module__border-r-3___jBJxU {
  border-radius: 3px !important;
}

.VisitCard-module__border-r-4___ZnDzW {
  border-radius: 4px !important;
}

.VisitCard-module__border-r-6___ebpGa {
  border-radius: 6px !important;
}

.VisitCard-module__border-r-10___YSasI {
  border-radius: 10px !important;
}

.VisitCard-module__border-r-12___ny9eb {
  border-radius: 12px !important;
}

.VisitCard-module__border-r-16___DrrSp {
  border-radius: 16px !important;
}

.VisitCard-module__border-r-50___LkGro {
  border-radius: 50% !important;
}

.VisitCard-module__primary-border___cKB2P {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.VisitCard-module__primary-border-b___sLoF4 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.VisitCard-module__primary-border-t___aET5M {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.VisitCard-module__primary-border-l___ApNFx {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.VisitCard-module__primary-border-r___ln3aS {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.VisitCard-module__secondary-border___VyN_g {
  border: 1px solid #637768;
}

.VisitCard-module__secondary-border-b___ZPk2D {
  border-bottom: 1px solid #637768;
}

.VisitCard-module__secondary-border-t___WSSGS {
  border-top: 1px solid #637768;
}

.VisitCard-module__secondary-border-l___IYyT_ {
  border-left: 1px solid #637768;
}

.VisitCard-module__secondary-border-r___nxsn0 {
  border-right: 1px solid #637768;
}

.VisitCard-module__gap-0___hJYIO {
  gap: 0 !important;
}

.VisitCard-module__gap-2___U1kRP {
  gap: 2px !important;
}

.VisitCard-module__gap-4___wou3m {
  gap: 4px !important;
}

.VisitCard-module__gap-5___Bl9cd {
  gap: 5px !important;
}

.VisitCard-module__gap-6___p4x1Y {
  gap: 6px !important;
}

.VisitCard-module__gap-8___jREkN {
  gap: 8px !important;
}

.VisitCard-module__gap-10___hBx0J {
  gap: 10px !important;
}

.VisitCard-module__gap-12___B9LqF {
  gap: 12px !important;
}

.VisitCard-module__gap-14___orMug {
  gap: 14px !important;
}

.VisitCard-module__gap-16___dQA9s {
  gap: 16px !important;
}

.VisitCard-module__gap-18___Lv_2Z {
  gap: 18px !important;
}

.VisitCard-module__gap-20___AQ8ZU {
  gap: 20px !important;
}

.VisitCard-module__gap-24___CRc05 {
  gap: 24px !important;
}

.VisitCard-module__gap-26___rQaj_ {
  gap: 26px !important;
}

.VisitCard-module__gap-30___C2ZEF {
  gap: 30px !important;
}

.VisitCard-module__gap-32___xV6U8 {
  gap: 32px !important;
}

.VisitCard-module__gap-40___Dt7Sn {
  gap: 40px !important;
}

.VisitCard-module__gap-50___YYuPJ {
  gap: 50px !important;
}

.VisitCard-module__flex-1___Io0R9 {
  flex: 1;
}

.VisitCard-module__flex-none___yo3vR {
  flex: none !important;
}

.VisitCard-module__flex-column___rJS4X {
  display: flex;
  flex-direction: column !important;
}

.VisitCard-module__flex-row___feAZE {
  display: flex;
  flex-direction: row !important;
}

.VisitCard-module__vertically-centered___DfnpR {
  display: flex;
  align-items: center !important;
}

.VisitCard-module__horizontally-centered___cjS_l {
  display: flex;
  justify-content: center !important;
}

.VisitCard-module__horizontally-end___eaqqh {
  display: flex;
  justify-content: end !important;
}

.VisitCard-module__vertically-start___e1RlY {
  display: flex;
  align-items: start !important;
}

.VisitCard-module__space-between___rC_jW {
  display: flex;
  justify-content: space-between !important;
}

.VisitCard-module__flex-wrap___toMyV {
  flex-wrap: wrap !important;
}

.VisitCard-module__height-100___BRlTT {
  height: 100%;
}

.VisitCard-module__width-50___cvh68 {
  width: 50% !important;
}

.VisitCard-module__width-100___dfGBq {
  width: 100%;
}

.VisitCard-module__cursor-pointer___To95P {
  cursor: pointer;
}

.VisitCard-module__cursor-not-allowed___lA1z2 {
  cursor: not-allowed !important;
}

.VisitCard-module__absolute-centered___rEjeq {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.VisitCard-module__absolute___fZyNJ {
  position: absolute;
}

.VisitCard-module__relative___ZE1yh {
  position: relative;
}

.VisitCard-module__fixed___Ybk1t {
  position: fixed;
}

.VisitCard-module__visible___ktHaL {
  opacity: 1;
}

.VisitCard-module__invisible___Zyuiz {
  opacity: 0;
}

.VisitCard-module__col-90____fhRc {
  width: 90% !important;
}

.VisitCard-module__col-auto___AvnlN {
  width: auto !important;
}

.VisitCard-module__medical-tabs___STfgd {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.VisitCard-module__medical-table-new___Ec55W {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.VisitCard-module__medical-table-new___Ec55W:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.VisitCard-module__medical-table-new___Ec55W::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.VisitCard-module__medical-table-new___Ec55W::-webkit-scrollbar-track {
  display: none;
}
.VisitCard-module__medical-table-new___Ec55W.VisitCard-module__no-pagination___mrDx0 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.VisitCard-module__medical-table-new___Ec55W.VisitCard-module__no-pagination___mrDx0:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.VisitCard-module__medical-table-new___Ec55W.VisitCard-module__no-pagination___mrDx0::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.VisitCard-module__medical-table-new___Ec55W.VisitCard-module__no-pagination___mrDx0::-webkit-scrollbar-track {
  display: none;
}

.VisitCard-module__medical-table-empty___DuN78 {
  padding: 14px 40px !important;
}

.VisitCard-module__icon-btn___gTRkE {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.VisitCard-module__search-icon___WrGa5 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.VisitCard-module__disable-select___LNmjg {
  user-select: none;
}

.VisitCard-module__break-word___vBC1u {
  word-break: break-word;
}

.VisitCard-module__popup-clear-btn___HwmQi {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.VisitCard-module__scroll-m-b-20___LU9V_ {
  scroll-margin-bottom: 20px;
}

.VisitCard-module__card___t7DGz {
  position: relative;
  overflow: hidden;
  border: 1.5px solid transparent;
  border-radius: 8px;
  background: #ffffff;
  line-height: 1.5;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.VisitCard-module__card___t7DGz:has(> .VisitCard-module__opener___M59Nn:focus-visible) {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}

.VisitCard-module__plain___jTTpb {
  border-color: #e4e4e7;
}
.VisitCard-module__plain___jTTpb:hover {
  border-color: #a1a1aa;
}

.VisitCard-module__ready___enRjD {
  border-color: #50ae3d;
  box-shadow: 0 1px 2px 0 rgba(80, 174, 61, 0.1), 0 4px 12px -4px rgba(80, 174, 61, 0.28);
}
.VisitCard-module__ready___enRjD:hover {
  border-color: #48813b;
  box-shadow: 0 1px 2px 0 rgba(80, 174, 61, 0.12), 0 6px 16px -4px rgba(80, 174, 61, 0.34);
}

.VisitCard-module__card___t7DGz.VisitCard-module__selected___fXbbb {
  border-color: #18181b;
  background: #fafafa;
  box-shadow: 0 0 0 1px #18181b;
}

.VisitCard-module__opener___M59Nn {
  position: absolute;
  inset: 0;
  z-index: 0;
  border: 0;
  border-radius: inherit;
  background: transparent;
  cursor: pointer;
  outline: none;
}

.VisitCard-module__content___Gocnb {
  position: relative;
  z-index: 1;
  pointer-events: none;
}
.VisitCard-module__content___Gocnb a,
.VisitCard-module__content___Gocnb button,
.VisitCard-module__content___Gocnb [role=button] {
  pointer-events: auto;
}

.VisitCard-module__squaresRow___CXp2t {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 8px;
}

.VisitCard-module__squares___tk3JJ {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
}

.VisitCard-module__square___WAkWV {
  width: 10px;
  height: 10px;
  border-radius: 2px;
}

.VisitCard-module__squareGreen___UyhwR {
  background: #22c55e;
}

.VisitCard-module__squareYellow___X_n20 {
  background: #eab308;
}

.VisitCard-module__squareRed___IlV_w {
  background: #ef4444;
}

.VisitCard-module__squareCanceled___zdu6F {
  background: #d4d4d8;
}

.VisitCard-module__count___T9EGE {
  line-height: 16px;
  white-space: nowrap;
  font-family: "IBM Plex Mono", monospace;
  font-size: 12px;
  font-weight: 500;
  color: #71717a;
}

.VisitCard-module__progress___yHbeP {
  display: flex;
  width: 100%;
  align-items: baseline;
  gap: 10px;
}

.VisitCard-module__track___d7MwG {
  height: 6px;
  flex: 1;
  align-self: center;
  overflow: hidden;
  border-radius: 2px;
  background: #f4f4f5;
}

.VisitCard-module__fill___qYzgy {
  display: block;
  height: 100%;
  border-radius: 2px;
  transition: width 0.4s ease-out;
}

.VisitCard-module__fillGreen___IQURz {
  background: #86efac;
}

.VisitCard-module__fillYellow___MjAMx {
  background: #fde68a;
}

.VisitCard-module__fillRed___rwAGR {
  background: #fecaca;
}

.VisitCard-module__fillNeutral___IBXeZ {
  background: #d4d4d8;
}

.VisitCard-module__progressWords___w1Pt_ {
  white-space: nowrap;
  font-family: "IBM Plex Mono", monospace;
  font-size: 13px;
  font-weight: 600;
  color: #52525b;
}

.VisitCard-module__allDone___KoQtw {
  color: #166534;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/Visit/VisitCard.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_visit.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;EACA,gBAAA;EACA,+BAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gDAAA;AA8pBF;AA5pBE;EACE,0BAAA;EACA,mBAAA;AA8pBJ;;AA1pBA;EACE,qBEbS;AF0qBX;AA3pBE;EACE,qBAAA;AA6pBJ;;AAzpBA;EACE,qBE1BM;EF2BN,uFEzBa;AFqrBf;AA1pBE;EACE,qBE7BW;EF8BX,wFE5BiB;AFwrBrB;;AAxpBA;EACE,qBAAA;EACA,mBAAA;EACA,6BAAA;AA2pBF;;AAxpBA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;AA2pBF;;AAxpBA;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;AA2pBF;AAzpBE;;;EAGE,oBAAA;AA2pBJ;;AAvpBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AA0pBF;;AAvpBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AA0pBF;;AAvpBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AA0pBF;;AAvpBA;EACE,mBAAA;AA0pBF;;AAvpBA;EACE,mBAAA;AA0pBF;;AAvpBA;EACE,mBAAA;AA0pBF;;AAvpBA;EACE,mBAAA;AA0pBF;;AAvpBA;EACE,iBAAA;EACA,mBAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,cElGM;AF4vBR;;AAvpBA;EACE,aAAA;EACA,WAAA;EACA,qBAAA;EACA,SAAA;AA0pBF;;AAvpBA;EACE,WAAA;EACA,OAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA0pBF;;AAvpBA;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;AA0pBF;;AAvpBA;EACE,mBAAA;AA0pBF;;AAvpBA;EACE,mBAAA;AA0pBF;;AAvpBA;EACE,mBAAA;AA0pBF;;AAvpBA;EACE,mBAAA;AA0pBF;;AAvpBA;EACE,mBAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA0pBF;;AAvpBA;EACE,cAAA;AA0pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.card {\n  position: relative;\n  overflow: hidden;\n  border: 1.5px solid transparent;\n  border-radius: 8px;\n  background: #ffffff;\n  line-height: 1.5;\n  transition: border-color 0.15s, box-shadow 0.15s;\n\n  &:has(> .opener:focus-visible) {\n    outline: 2px solid $focus;\n    outline-offset: 1px;\n  }\n}\n\n.plain {\n  border-color: $hairline;\n\n  &:hover {\n    border-color: #a1a1aa;\n  }\n}\n\n.ready {\n  border-color: $ready;\n  box-shadow: $ready-shadow;\n\n  &:hover {\n    border-color: $ready-strong;\n    box-shadow: $ready-shadow-hover;\n  }\n}\n\n.card.selected {\n  border-color: #18181b;\n  background: #fafafa;\n  box-shadow: 0 0 0 1px #18181b;\n}\n\n.opener {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  border: 0;\n  border-radius: inherit;\n  background: transparent;\n  cursor: pointer;\n  outline: none;\n}\n\n.content {\n  position: relative;\n  z-index: 1;\n  pointer-events: none;\n\n  a,\n  button,\n  [role='button'] {\n    pointer-events: auto;\n  }\n}\n\n.squaresRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px 8px;\n}\n\n.squares {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px;\n}\n\n.square {\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n}\n\n.squareGreen {\n  background: #22c55e;\n}\n\n.squareYellow {\n  background: #eab308;\n}\n\n.squareRed {\n  background: #ef4444;\n}\n\n.squareCanceled {\n  background: #d4d4d8;\n}\n\n.count {\n  line-height: 16px;\n  white-space: nowrap;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 12px;\n  font-weight: 500;\n  color: $label;\n}\n\n.progress {\n  display: flex;\n  width: 100%;\n  align-items: baseline;\n  gap: 10px;\n}\n\n.track {\n  height: 6px;\n  flex: 1;\n  align-self: center;\n  overflow: hidden;\n  border-radius: 2px;\n  background: #f4f4f5;\n}\n\n.fill {\n  display: block;\n  height: 100%;\n  border-radius: 2px;\n  transition: width 0.4s ease-out;\n}\n\n.fillGreen {\n  background: #86efac;\n}\n\n.fillYellow {\n  background: #fde68a;\n}\n\n.fillRed {\n  background: #fecaca;\n}\n\n.fillNeutral {\n  background: #d4d4d8;\n}\n\n.progressWords {\n  white-space: nowrap;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 13px;\n  font-weight: 600;\n  color: #52525b;\n}\n\n.allDone {\n  color: #166534;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","$ready: #50ae3d;\n$ready-strong: #48813b;\n$ready-shadow: 0 1px 2px 0 rgba($ready, 0.1), 0 4px 12px -4px rgba($ready, 0.28);\n$ready-shadow-hover: 0 1px 2px 0 rgba($ready, 0.12), 0 6px 16px -4px rgba($ready, 0.34);\n\n$hairline: #e4e4e7;\n$rule: #f4f4f5;\n$label: #71717a;\n$focus: #18181b;\n$tracking-caps: 0.08em;\n\n$visit-kinds: (\n  followUp: (\n    base: #69945f,\n    strong: #48813b,\n  ),\n  consultation: (\n    base: #6687bd,\n    strong: #4972b7,\n  ),\n  infusion: (\n    base: #8e7ab5,\n    strong: #8065b1,\n  ),\n  assessment: (\n    base: #3c9888,\n    strong: #088272,\n  ),\n  carePlan: (\n    base: #3c93ac,\n    strong: #0b7d97,\n  ),\n  other: (\n    base: #7e8791,\n    strong: #6b747e,\n  ),\n);\n\n@mixin focus-ring($offset: 1px) {\n  outline: none;\n\n  &:focus-visible {\n    outline: 2px solid $focus;\n    outline-offset: $offset;\n  }\n}\n\n@mixin line-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  color: #18181b;\n  text-decoration: underline;\n  text-decoration-color: #d4d4d8;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  transition: background-color 0.15s, border-color 0.15s;\n\n  &:hover:not(:disabled) {\n    border-color: #d4d4d8;\n    background: #ffffff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    text-decoration: none;\n  }\n\n  @include focus-ring;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `VisitCard-module__font-s-10___qrF1n`,
	"fontS12": `VisitCard-module__font-s-12___gIXBY`,
	"fontS13": `VisitCard-module__font-s-13___w66j6`,
	"fontS14": `VisitCard-module__font-s-14___uRsM7`,
	"fontS15": `VisitCard-module__font-s-15___BhIoa`,
	"fontS16": `VisitCard-module__font-s-16___oZeG0`,
	"fontS18": `VisitCard-module__font-s-18___u21na`,
	"fontS20": `VisitCard-module__font-s-20___Hvxsr`,
	"fontS22": `VisitCard-module__font-s-22___NBR20`,
	"fontS28": `VisitCard-module__font-s-28___rmqBd`,
	"fontW400": `VisitCard-module__font-w-400___BpTCa`,
	"fontW500": `VisitCard-module__font-w-500___Bxqr_`,
	"fontW600": `VisitCard-module__font-w-600___RycOf`,
	"fontW700": `VisitCard-module__font-w-700___hlrie`,
	"p5": `VisitCard-module__p-5___FOjBl`,
	"p12": `VisitCard-module__p-12___CtKEc`,
	"p16": `VisitCard-module__p-16___U7Y7t`,
	"p30": `VisitCard-module__p-30___izHlB`,
	"pB0": `VisitCard-module__p-b-0___MU94H`,
	"pB5": `VisitCard-module__p-b-5___bFPAS`,
	"pB10": `VisitCard-module__p-b-10___nwgoa`,
	"pB12": `VisitCard-module__p-b-12___Kc1me`,
	"pB16": `VisitCard-module__p-b-16___dJ4Dm`,
	"pB18": `VisitCard-module__p-b-18___bEzZi`,
	"pB20": `VisitCard-module__p-b-20___ibEa6`,
	"pB25": `VisitCard-module__p-b-25___DdpHW`,
	"pB30": `VisitCard-module__p-b-30___vAbs8`,
	"pB50": `VisitCard-module__p-b-50___PxCsz`,
	"pT0": `VisitCard-module__p-t-0___WFBpv`,
	"pT12": `VisitCard-module__p-t-12___rSfuw`,
	"pT16": `VisitCard-module__p-t-16___v1DVY`,
	"pT18": `VisitCard-module__p-t-18___ED5Kx`,
	"pT20": `VisitCard-module__p-t-20___w2bdn`,
	"pT30": `VisitCard-module__p-t-30___voVZL`,
	"pT40": `VisitCard-module__p-t-40___vN2PA`,
	"pT50": `VisitCard-module__p-t-50___HVtOB`,
	"pL20": `VisitCard-module__p-l-20___GUJGv`,
	"pL30": `VisitCard-module__p-l-30____t9fI`,
	"pL40": `VisitCard-module__p-l-40___XyBJe`,
	"pR16": `VisitCard-module__p-r-16___HWowV`,
	"pR20": `VisitCard-module__p-r-20___xJOlN`,
	"pR30": `VisitCard-module__p-r-30___usQUR`,
	"pR50": `VisitCard-module__p-r-50___nO225`,
	"pR60": `VisitCard-module__p-r-60___bMjbt`,
	"mB1": `VisitCard-module__m-b-1___QsHJk`,
	"mB2": `VisitCard-module__m-b-2___bhV7P`,
	"mB6": `VisitCard-module__m-b-6___SdN63`,
	"mB8": `VisitCard-module__m-b-8___BSmTH`,
	"mB10": `VisitCard-module__m-b-10___lS_jU`,
	"mB14": `VisitCard-module__m-b-14___rHIRu`,
	"mB16": `VisitCard-module__m-b-16___Usj5a`,
	"mB20": `VisitCard-module__m-b-20___DzyMH`,
	"mB22": `VisitCard-module__m-b-22___hKokZ`,
	"mB24": `VisitCard-module__m-b-24___xdgUg`,
	"mB30": `VisitCard-module__m-b-30___FsYlM`,
	"mB32": `VisitCard-module__m-b-32___s1jkL`,
	"mB40": `VisitCard-module__m-b-40___ok2lJ`,
	"mT2": `VisitCard-module__m-t-2___K_Eem`,
	"mT3": `VisitCard-module__m-t-3___mY5S4`,
	"mT4": `VisitCard-module__m-t-4___th6ZD`,
	"mT5": `VisitCard-module__m-t-5____YOg3`,
	"mT8": `VisitCard-module__m-t-8___RnZzg`,
	"mT10": `VisitCard-module__m-t-10___HBI5D`,
	"mT15": `VisitCard-module__m-t-15___YLZ8q`,
	"mT16": `VisitCard-module__m-t-16___blLyi`,
	"mT20": `VisitCard-module__m-t-20___DbP0f`,
	"mT22": `VisitCard-module__m-t-22___rihb2`,
	"mT30": `VisitCard-module__m-t-30___a5dD2`,
	"mT32": `VisitCard-module__m-t-32___Upqu8`,
	"mLAuto": `VisitCard-module__m-l-auto___y_iog`,
	"mL4": `VisitCard-module__m-l-4___tpsRb`,
	"mL5": `VisitCard-module__m-l-5___dkA9k`,
	"mL6": `VisitCard-module__m-l-6___UOpjn`,
	"mL8": `VisitCard-module__m-l-8___U0hG4`,
	"mL10": `VisitCard-module__m-l-10___GCLem`,
	"mL16": `VisitCard-module__m-l-16___bSxKQ`,
	"mL20": `VisitCard-module__m-l-20___uCk3D`,
	"mL24": `VisitCard-module__m-l-24___VhVR6`,
	"mL30": `VisitCard-module__m-l-30___ZyBCO`,
	"mL35": `VisitCard-module__m-l-35____2mXI`,
	"mL40": `VisitCard-module__m-l-40___crkfs`,
	"mR8": `VisitCard-module__m-r-8___ZsHVF`,
	"mR10": `VisitCard-module__m-r-10___hFPgp`,
	"mR16": `VisitCard-module__m-r-16___rAGf6`,
	"mR20": `VisitCard-module__m-r-20___OL7xT`,
	"mR24": `VisitCard-module__m-r-24___SesnN`,
	"mR30": `VisitCard-module__m-r-30___HBk61`,
	"mR40": `VisitCard-module__m-r-40___xcTZC`,
	"borderR3": `VisitCard-module__border-r-3___jBJxU`,
	"borderR4": `VisitCard-module__border-r-4___ZnDzW`,
	"borderR6": `VisitCard-module__border-r-6___ebpGa`,
	"borderR10": `VisitCard-module__border-r-10___YSasI`,
	"borderR12": `VisitCard-module__border-r-12___ny9eb`,
	"borderR16": `VisitCard-module__border-r-16___DrrSp`,
	"borderR50": `VisitCard-module__border-r-50___LkGro`,
	"primaryBorder": `VisitCard-module__primary-border___cKB2P`,
	"primaryBorderB": `VisitCard-module__primary-border-b___sLoF4`,
	"primaryBorderT": `VisitCard-module__primary-border-t___aET5M`,
	"primaryBorderL": `VisitCard-module__primary-border-l___ApNFx`,
	"primaryBorderR": `VisitCard-module__primary-border-r___ln3aS`,
	"secondaryBorder": `VisitCard-module__secondary-border___VyN_g`,
	"secondaryBorderB": `VisitCard-module__secondary-border-b___ZPk2D`,
	"secondaryBorderT": `VisitCard-module__secondary-border-t___WSSGS`,
	"secondaryBorderL": `VisitCard-module__secondary-border-l___IYyT_`,
	"secondaryBorderR": `VisitCard-module__secondary-border-r___nxsn0`,
	"gap0": `VisitCard-module__gap-0___hJYIO`,
	"gap2": `VisitCard-module__gap-2___U1kRP`,
	"gap4": `VisitCard-module__gap-4___wou3m`,
	"gap5": `VisitCard-module__gap-5___Bl9cd`,
	"gap6": `VisitCard-module__gap-6___p4x1Y`,
	"gap8": `VisitCard-module__gap-8___jREkN`,
	"gap10": `VisitCard-module__gap-10___hBx0J`,
	"gap12": `VisitCard-module__gap-12___B9LqF`,
	"gap14": `VisitCard-module__gap-14___orMug`,
	"gap16": `VisitCard-module__gap-16___dQA9s`,
	"gap18": `VisitCard-module__gap-18___Lv_2Z`,
	"gap20": `VisitCard-module__gap-20___AQ8ZU`,
	"gap24": `VisitCard-module__gap-24___CRc05`,
	"gap26": `VisitCard-module__gap-26___rQaj_`,
	"gap30": `VisitCard-module__gap-30___C2ZEF`,
	"gap32": `VisitCard-module__gap-32___xV6U8`,
	"gap40": `VisitCard-module__gap-40___Dt7Sn`,
	"gap50": `VisitCard-module__gap-50___YYuPJ`,
	"flex1": `VisitCard-module__flex-1___Io0R9`,
	"flexNone": `VisitCard-module__flex-none___yo3vR`,
	"flexColumn": `VisitCard-module__flex-column___rJS4X`,
	"flexRow": `VisitCard-module__flex-row___feAZE`,
	"verticallyCentered": `VisitCard-module__vertically-centered___DfnpR`,
	"horizontallyCentered": `VisitCard-module__horizontally-centered___cjS_l`,
	"horizontallyEnd": `VisitCard-module__horizontally-end___eaqqh`,
	"verticallyStart": `VisitCard-module__vertically-start___e1RlY`,
	"spaceBetween": `VisitCard-module__space-between___rC_jW`,
	"flexWrap": `VisitCard-module__flex-wrap___toMyV`,
	"height100": `VisitCard-module__height-100___BRlTT`,
	"width50": `VisitCard-module__width-50___cvh68`,
	"width100": `VisitCard-module__width-100___dfGBq`,
	"cursorPointer": `VisitCard-module__cursor-pointer___To95P`,
	"cursorNotAllowed": `VisitCard-module__cursor-not-allowed___lA1z2`,
	"absoluteCentered": `VisitCard-module__absolute-centered___rEjeq`,
	"absolute": `VisitCard-module__absolute___fZyNJ`,
	"relative": `VisitCard-module__relative___ZE1yh`,
	"fixed": `VisitCard-module__fixed___Ybk1t`,
	"visible": `VisitCard-module__visible___ktHaL`,
	"invisible": `VisitCard-module__invisible___Zyuiz`,
	"col90": `VisitCard-module__col-90____fhRc`,
	"colAuto": `VisitCard-module__col-auto___AvnlN`,
	"medicalTabs": `VisitCard-module__medical-tabs___STfgd`,
	"medicalTableNew": `VisitCard-module__medical-table-new___Ec55W`,
	"noPagination": `VisitCard-module__no-pagination___mrDx0`,
	"medicalTableEmpty": `VisitCard-module__medical-table-empty___DuN78`,
	"iconBtn": `VisitCard-module__icon-btn___gTRkE`,
	"searchIcon": `VisitCard-module__search-icon___WrGa5`,
	"disableSelect": `VisitCard-module__disable-select___LNmjg`,
	"breakWord": `VisitCard-module__break-word___vBC1u`,
	"popupClearBtn": `VisitCard-module__popup-clear-btn___HwmQi`,
	"scrollMB20": `VisitCard-module__scroll-m-b-20___LU9V_`,
	"card": `VisitCard-module__card___t7DGz`,
	"opener": `VisitCard-module__opener___M59Nn`,
	"plain": `VisitCard-module__plain___jTTpb`,
	"ready": `VisitCard-module__ready___enRjD`,
	"selected": `VisitCard-module__selected___fXbbb`,
	"content": `VisitCard-module__content___Gocnb`,
	"squaresRow": `VisitCard-module__squaresRow___CXp2t`,
	"squares": `VisitCard-module__squares___tk3JJ`,
	"square": `VisitCard-module__square___WAkWV`,
	"squareGreen": `VisitCard-module__squareGreen___UyhwR`,
	"squareYellow": `VisitCard-module__squareYellow___X_n20`,
	"squareRed": `VisitCard-module__squareRed___IlV_w`,
	"squareCanceled": `VisitCard-module__squareCanceled___zdu6F`,
	"count": `VisitCard-module__count___T9EGE`,
	"progress": `VisitCard-module__progress___yHbeP`,
	"track": `VisitCard-module__track___d7MwG`,
	"fill": `VisitCard-module__fill___qYzgy`,
	"fillGreen": `VisitCard-module__fillGreen___IQURz`,
	"fillYellow": `VisitCard-module__fillYellow___MjAMx`,
	"fillRed": `VisitCard-module__fillRed___rwAGR`,
	"fillNeutral": `VisitCard-module__fillNeutral___IBXeZ`,
	"progressWords": `VisitCard-module__progressWords___w1Pt_`,
	"allDone": `VisitCard-module__allDone___KoQtw`
};
module.exports = ___CSS_LOADER_EXPORT___;
